import { render, staticRenderFns } from "./GameEdit.vue?vue&type=template&id=4c757cf2"
import script from "./GameEdit.vue?vue&type=script&lang=js"
export * from "./GameEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports